import React, { useState } from 'react'
import { Form, Formik } from 'formik'
import axiosService from '../../../utils/AxiosService';
import { Person, Eye, EyeSlash } from 'react-bootstrap-icons';
import { toastError } from '../../FormComponents/Toasts';
import Input from '../../FormComponents/Input'
import { LoginProjectManagerSchema } from '../../../schemas/ProjectManager/LoginProjectManagerSchema'
import { useNavigate } from 'react-router-dom';

const LoginForm = ({ processSubmit }) => {
  const [showPassword, setShowPassword] = useState(false)
  const navigate = useNavigate()

  const togglePasswordVisibility = (e) => {
    e.preventDefault();

    setShowPassword(!showPassword)
  }

  const handleLogin = (project_manager) => {
    axiosService.post('/api/project_manager/login', { project_manager })
      .then((resp) => processSubmit(resp.first_login))
      .catch(({ data: { error } }) => toastError(error))
  }

  return (
    <>
      <h2 className='font-bold text-xl mb-5'>Sign in to your account</h2>
      <Formik
        initialValues={{
          email: '',
          password: '',
        }}
        validationSchema={LoginProjectManagerSchema}
        onSubmit={handleLogin}
      >
        {({ errors, touched, handleBlur, handleChange, values }) => (
          <Form>
            <div className="relative">
              <Input
                error={touched.email && errors.email}
                label="Email"
                name="email"
                noLabelPadding
                placeholder="Email"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.email}
                addon={<Person />}
                addonPosition="end"
                addonColor="text-rb-dark-mode"
                autoComplete="email"
              />
            </div>
            <div className="relative">
              <Input
                error={touched.password && errors.password}
                label="Password"
                name="password"
                noLabelPadding
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="Password"
                value={values.password}
                type={showPassword ? 'text': 'password'}
                addonPosition="end"
                addon={showPassword ? <Eye /> : <EyeSlash />}
                onAddonClick={togglePasswordVisibility}
                addonColor="text-rb-dark-mode"
                autoComplete="current-password"
              />
            </div>
            <div className="flex justify-between py-3">
              <span className='text-sm'>
                Forgot your password?
              </span>
              <button
                className="text-sm text-rb-green"
                type="button"
                onClick={() => navigate('/project_manager/forgotten_password')}
              >
                Get a new one!
              </button>
            </div>
            <button
              type="submit"
              className="submit text-white bg-rb-green rounded-lg w-full py-2 text-center active:shadow-outer dark:text-rb-dark-mode"
            >
              Sign in
            </button>
          </Form>
        )}
      </Formik>
    </>
   );
}

export default LoginForm;
